
/**
 * Utility functions for handling experience levels
 */

/**
 * Convert experience level string to years number
 */
export function getYearsFromExperienceLevel(level: string): number {
  switch (level) {
    case 'less_than_1': return 0;
    case '1_to_2': return 1;
    case '3_to_5': return 3;
    case '6_to_10': return 6;
    case '11_to_15': return 11;
    case '16_to_20': return 16;
    case 'more_than_20': return 21;
    default: return 0;
  }
}

/**
 * Convert years number to experience level string
 */
export function getExperienceLevelFromYears(years: number | null): string {
  if (years === null || years === undefined) return '';
  
  if (years < 1) return 'less_than_1';
  if (years <= 2) return '1_to_2';
  if (years <= 5) return '3_to_5';
  if (years <= 10) return '6_to_10';
  if (years <= 15) return '11_to_15';
  if (years <= 20) return '16_to_20';
  return 'more_than_20';
}
